import { render, staticRenderFns } from "./VThrottlerInput.vue?vue&type=template&id=060b3ca2"
import script from "./VThrottlerInput.vue?vue&type=script&lang=ts"
export * from "./VThrottlerInput.vue?vue&type=script&lang=ts"
import style0 from "./VThrottlerInput.vue?vue&type=style&index=0&id=060b3ca2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports